module.exports = __webpack_public_path__ + "static/img/SensingtechLogo.6129630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SensingtechLogo.jpg
// module id = mGYi
// module chunks = 31